<template>
  <div class="index">
    <el-carousel class="swiper index-swiper">
      <el-carousel-item class="swiper-item">
        <img class="swiper-item-img" src="../assets/ban2.png" alt="" />
      </el-carousel-item>
      <el-carousel-item class="swiper-item">
        <img class="swiper-item-img" src="../assets/ban3.png" alt="" />
      </el-carousel-item>
    </el-carousel>
    <div class="index-con">
      <div class="message">
        <div class="title">FIFS & ISNFF 2024</div>
        <div class="small-title">
          <div class="small-title3">
            2024 International Journal Forum on Interdisciplinary Food Science
            <br />
            (Food Bioscience & Food Nutrition)
            <br />
            joint with the 16th Conference and Exhibition of the International
            <br />
            Society for Nutraceuticals and Functional Foods
          </div>
        </div>
        <div class="small-title2">(FIFS & ISNFF 2024)</div>
        <div class="small-title2">Theme: Food4Future</div>
        <div class="small-title2">December 3-6, 2024, Wuxi, China</div>
        <div class="line"></div>
        <div class="text">
          Jiangnan University, Elsevier and ISNFF are delighted to announce that
          <b>the 2024 International Journal Forum on Interdisciplinary Food
            Science (Food Bioscience & Food Nutrition) joint with the 16th ISNFF
            Conference and Exhibition: Food4Future</b>
          will take place in Wuxi, China, December 3-6, 2024.
          <br /><br />
          Rapid population
          growth and overexploitation of resources have resulted in food
          shortages and potential food security issues. Additionally, unhealthy
          lifestyles and dietary habits have led to a global increase in chronic
          diseases, presenting significant public health challenges. The
          integration of interdisciplinary food sciences, such as food
          bioscience and food nutrition, could provide a solution to global food
          security issues, famine, and public health problems.

          <br /><br />
          To foster academic exchange and technological innovation in the field
          of interdisciplinary food science, the journals <i>Food Bioscience</i> and
          <i>Food Nutrition</i> are jointly initiating
          <b>FIFS2024</b>. The conference is co-hosted by Jiangnan University,
          Elsevier and ISNFF and is co-organized by the School of Food Science
          and Technology at Jiangnan University, the Food Academic Journal
          Center of Jiangnan University and Jiangsu Institute of Food Science
          and Technology. <br /><br />

          The conference aims to focus on current issues in the field of
          interdisciplinary food science,nutraceuticals and functional foods. We invite renowned experts, scholars,
          and industry representatives from around the world to network with the
          world’s best research on interdisciplinary food science and to engage
          in in-depth discussions about the future and innovative opportunities
          in the field. The ISNFF sessions will be related to Food Bioactives
          (proteins and peptides, lipids, carbohydrates and polyphenols) and
          their metabolites and health effects, among other relevant topics.
          <br /><br />
          <p>
            <b>Conference Topics</b>
          </p>
          Oral and Poster abstracts are now invited on the following topics.
          They should be submitted using
          <span class="text-blue" @click="toReg">
            the online abstract submission system.
          </span>
          <p>1. Biochemical, biophysical and biological properties of foods</p>
          <p>
            2. Genetic, cellular and molecular biology in food production and
            processing
          </p>
          <p>3. Biomaterials for food-related systems</p>
          <p>4. Application of novel technology to foods</p>
          <p>
            5. Exploration of food functional factors and analysis of their
            mechanisms
          </p>
          <p>6. Food nutrition for specific (special) populations</p>
          <p>7. Interactions between food components and gut microbiota</p>
          <p>8. Food, immunity and metabolism</p>
          <p>
            9. Major Food Bioactives (proteins and peptides, lipids,
            carbohydrates)
          </p>
          <p>
            10. Polyphenols, carotenoids, their metabolites and health effects
          </p>
          <p>11. Microbiome, pre- and probiotics and health implications</p>
          <p>12. Controlled release and delivery of functional ingredients</p>
          <p>13. Bioaccessibility and bioavailability of food bioactives</p>
          <p>14. Obesity, diabetes and metabolic syndrome</p>
          <p>15. Upcycling of food processing discards</p>
          <p>16. Artificial intelligence and Other topics</p>
        </div>
      </div>
      <div class="type-lists">
        <div class="type-list">
          <div class="title">
            <span class="square"></span>
            Registration
          </div>
          <div class="text">
            Please access the registration system, fill in your information and
            pay online.
          </div>
          <div class="d-f" style="display: flex">
            <div class="btn" style="margin-right: 20px" @click="toOther('/register')">
              <span>Registration</span>
            </div>
            <div class="btn" @click="toOther('/login')">
              <span>Login</span>
            </div>
          </div>
          <!--div class="text">
            For more information, please click:
            <span class="text-blue" @click="toOther('/submissions')">Registration</span>
          </！div-->
          <img class="pic" src="../assets/301240322151743389.jpg" alt="" />
        </div>
        <div class="type-list">
          <div class="title">
            <span class="square"></span>
            Call For Abstracts
          </div>
          <div class="text">
            Abstracts relating to the conference topics are invited for “Oral
            Presentations” or “Poster Presentations” by
            <b>October 30，2024（Beijing Time）</b>.
          </div>
          <div class="btn" @click="toOther('/submissions')">
            <span> Call For Abstracts</span>
          </div>
          <div class="text">
            <img class="gif" src="https://fhk.ais.cn/cms/website/editor/202304/326230403144454505.gif" alt="" />
            Please submit your abstract online after registration.
          </div>
          <a class="text" style="
              background: lightcyan;
              display: inline-block;
              cursor: pointer;
              padding: 0 6px;
              color: #555;
            " href="https://www.fifs-isnff-2024.cn/public/uploads/Abstract%20Submission%20Template.doc">
            <i style="color: blue" class="el-icon-document"></i>
            Abstract Submission Template
          </a>
          <br />
          <div class="text">
            <div class="title">
              <span class="square"></span>
              Awards
            </div>
            Student Competition Award (Oral and Poster)<br />
            Elsevier Young Scientist Award<br />
            ISNFF Young Scientist Award<br />
            Fereidoon SHAHIDI Fellowship Award<br />
            ISNFF Fellow Award <br />
            Lifetime Achievement Award <br />
            Merit Award<br /><br />
            <div class="btn" @click="toOther('/Awards')">
              <span>See the awards here</span>
            </div>
            <!--
            The scientific committee of the symposium invites applicants for a
            Young Scientist Award. If you are a young scientist (student, PhD
            student or equivalent) and your submitted abstract is accepted for a
            presentation in the poster sessions, …  <br />
            First Prize: USD 500 <br />
            Second Prize: USD 300 <br />
            Third Prize: USD 200-->
          </div>
        </div>
        <!-- <div class="type-list">
          <div class="title">
            <span class="square"></span>
            Call For Papers
          </div>
          <div class="text">
            <img class="gif" src="https://fhk.ais.cn/cms/website/editor/202304/326230403144454505.gif" alt="" />
            The topics of interest for submission include, but are not limited
            to:
          </div>

          <div class="btn" @click="toOther('/submissions')">
            <span> Call For Papers</span>
          </div>
        </div> -->
        <!-- <div class="type-list">
          <div class="title">
            <span class="square"></span>
            Publication
          </div>
          <div class="text">
            <img
              class="gif"
              src="https://fhk.ais.cn/cms/website/editor/202304/326230403154519809.gif"
              alt=""
            />
            All papers will be reviewed by two or three expert reviewers from
            the conference committees. After a careful reviewing process, all
            accepted papers will be published in the Conference Proceedings, and
            submitted to EI Compendex, Scopus for indexing.
          </div>
        </div>
        <div class="flex-1">
          <b>Both Abstract and Full Paper are welcomed.</b> All submitted
          articles should report original results, experimental or theoretical,
          not previously published or being under consideration for publication
          elsewhere. Articles submitted to the conference should meet these
          criteria. We firmly believe that ethical conduct is the most essential
          virtue of any academics. Hence, any act of plagiarism or other
          misconduct is totally unacceptable and cannot be tolerated.
        </div> -->
      </div>
      <div class="two-swiper">
        <el-carousel :interval="4000" type="card" height="250px">
          <el-carousel-item>
            <img class="swiper-item-img" src="../assets/ban2.png" alt="" />
          </el-carousel-item>
          <el-carousel-item>
            <img class="swiper-item-img" src="../assets/ban3.png" alt="" />
          </el-carousel-item>
          <el-carousel-item>
            <img class="swiper-item-img" src="../assets/ban2.png" alt="" />
          </el-carousel-item>
          <el-carousel-item>
            <img class="swiper-item-img" src="../assets/ban3.png" alt="" />
          </el-carousel-item>
          <el-carousel-item>
            <img class="swiper-item-img" src="../assets/ban2.png" alt="" />
          </el-carousel-item>
          <el-carousel-item>
            <img class="swiper-item-img" src="../assets/ban3.png" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="dates">
      <div class="index-con">
        <div class="title">Important Dates</div>
        <div class="lists">
          <div class="list">
            <p>Abstract Submission Deadline</p>
            <p>
              <b>October 30，2024（Beijing Time）</b>
            </p>
          </div>
          <div class="list">
            <p>Author Notification Deadline</p>
            <p>
              <b>November 15，2024（Beijing Time）</b>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="index-con">

      <div class="people">
        <div class="people-title bg-green">
          <i class="el-icon-user"></i>
          <b>Experts Attending the Conference </b>( To be updated )
        </div>
        <div class="title-big">
          Plenary Speakers
        </div>
        <el-carousel class="people-lists-contents" :loop="true" :autoplay="true">
          <el-carousel-item class="people-lists">
            <div class="people-list" v-for="(item, index) in speakListA" :key="index">
              <div class="people-pic">
                <img v-if="item.image_url" :src="'https://www.fifs-isnff-2024.cn/public/' +
                  item.image_url
                  " alt="" />
              </div>
              <div class="peoples-title">
                <b>{{ item.news_title }}</b>
              </div>
              <div class="people-text">{{ item.writer }}</div>
              <div class="people-text text-999">{{ item.source }}</div>
            </div>
          </el-carousel-item>
          <el-carousel-item class="people-lists">
            <div class="people-list" v-for="(item, index) in speakListB" :key="index">
              <div class="people-pic">
                <img v-if="item.image_url" :src="'https://www.fifs-isnff-2024.cn/public/' +
                  item.image_url
                  " alt="" />
              </div>
              <div class="peoples-title">
                <b>{{ item.news_title }}</b>
              </div>
              <div class="people-text">{{ item.writer }}</div>
              <div class="people-text text-999">{{ item.source }}</div>
            </div>

            <!-- <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Bradley.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Bradley Bolling</b>
              </div>
              <div class="people-text">University of Wisconsin-Madison</div>
              <div class="people-text text-999">USA</div>
            </div> 
            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Chi-Tang.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Chi-Tang Ho</b>
              </div>
              <div class="people-text">Rutgers University</div>
              <div class="people-text text-999">USA</div>
            </div>
            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Kazuo.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Kazuo Miyashita</b>
              </div>
              <div class="people-text">Hokkaido Bunkyo University</div>
              <div class="people-text text-999">Japan</div>
            </div> 
            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Ronald.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Ronald Pegg</b>
              </div>
              <div class="people-text">University of Georgia</div>
              <div class="people-text text-999">Canada</div>
            </div>
            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Fereidoon.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Fereidoon Shahidi</b>
              </div>
              <div class="people-text">Memorial University</div>
              <div class="people-text text-999">Canada</div>
            </div>
            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Jerzy.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Jerzy Zawistowski</b>
              </div>
              <div class="people-text">University of British Columbia</div>
              <div class="people-text text-999">Canada</div>
            </div>  -->
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <div class="index-con">
      <div class="people">
        <div class="title-big">
          Other Experts
        </div>
        <div class="btn" @click="toOther('/committee')">
          <span>See Other Experts Attending the Conference here</span>
        </div>
        <!-- <el-carousel class="people-lists-contents" :loop="true" :autoplay="true">
          <el-carousel-item class="people-lists"> 

            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Cesarettin.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Cesarettin Alasalvar</b>
              </div>
              <div class="people-text">Food Institute of TÜBİTAK MRC</div>
              <div class="people-text text-999">Turkiye</div>
            </div>

            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Rotimi.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Rotimi Aluko</b>
              </div>
              <div class="people-text">University of Manitoba</div>
              <div class="people-text text-999">Canada</div>
            </div>

            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Carlos.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Carlos L. Cespedes-Acuña</b>
              </div>
              <div class="people-text">University of Bio Bio</div>
              <div class="people-text text-999">Chile</div>
            </div>

            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Ying.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Ying Li</b>
              </div>
              <div class="people-text">Jiangsu Academy of Agricultural Sciences</div>
              <div class="people-text text-999">China</div>
            </div>
            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Katia.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Katia Liburdi</b>
              </div>
              <div class="people-text">University of Tuscia</div>
              <div class="people-text text-999">Viterbo, Italy</div>
            </div>


            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/John.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>John Muyonga</b>
              </div>
              <div class="people-text">Makerere University</div>
              <div class="people-text text-999">Uganda</div>
            </div>

          </el-carousel-item>
          <el-carousel-item class="people-lists"> 
            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Hyun.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Hyun Jin Park</b>
              </div>
              <div class="people-text">Korea University</div>
              <div class="people-text text-999">South Korea</div>
            </div>

            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Tatiana.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Tatiana Pimentel </b>
              </div>
              <div class="people-text">Federal Institute of Parana</div>
              <div class="people-text text-999">Brazil</div>
            </div>

            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Kenji.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Kenji Sato</b>
              </div>
              <div class="people-text">Kyoto University</div>
              <div class="people-text text-999">Japan</div>
            </div>


            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Giuseppe.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Giuseppe Spano</b>
              </div>
              <div class="people-text">University of Foggia</div>
              <div class="people-text text-999">Italy</div>
            </div>


            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Rong.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Rong Tsao</b>
              </div>
              <div class="people-text">Agriculture and Agri-Food Canada</div>
              <div class="people-text text-999">Canada</div>
            </div>

            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Mingfu.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Mingfu Wang</b>
              </div>
              <div class="people-text">Shenzhen University</div>
              <div class="people-text text-999">China</div>
            </div>

            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Youling.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Youling L Xiong</b>
              </div>
              <div class="people-text">University of Kentucky</div>
              <div class="people-text text-999">USA</div>
            </div>


          </el-carousel-item> 
        </el-carousel> -->
      </div>
    </div>
    <div class="index-con">
      <div class="contact-us bg-green">
        <div class="contact-title">Contact Information</div>
        <div class="contact-con">
          <p class="contact-text">
            <!-- <b> Address:</b> -->
            Selena Zhou
          </p>
          <div class="em-web">
            <p><b>Tel:</b>+86-0510-85197031</p>
            <p><b>Email: </b>fifs@jiangnan.edu.cn</p>
          </div>
        </div>
      </div>

      <div class="type-lists">
        <div class="type-list flex-1">
          <div class="title">
            <span class="square"></span>
            Hosted By
          </div>
          <div class="pics">
            <img height="80" width="80" src="../assets/jd.png" alt="" />
            &nbsp; &nbsp;
            <img height="80" width="80" src="../assets/p1.png" alt="" />
            &nbsp; &nbsp;
            <img height="80" width="100" src="../assets/small.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      speakListA: [],
      speakListB: [],
      type_id: '',

    };
  },
  onload() {

  },
  mounted() {
    this.getspeakListA();
    this.getspeakListB();
  },

  methods: {
    toReg() {
      this.$router.push("/reg");
    },
    toOther(url) {
      this.$router.push(url);
    },
    getspeakListA() {
      var params = {
        type_id: 830,
      };
      var that = this;
      this.$http.speaker_listA(params).then((res) => {
        that.speakListA = res.data;
      });
    },
    getspeakListB() {
      var params = {
        type_id: 830,
      };
      var that = this;
      this.$http.speaker_listB(params).then((res) => {

        that.speakListB = res.data;
      });
    },
  },
};
</script>

<style scoped lang="less">
.swiper {
  max-width: 1200px;
  margin: 0 auto;
}

.title-big {
  color: #595959;
  font-size: 20px;
  font-weight: 600;

  align-items: center;
  margin-bottom: 14px;
  margin-top: 14px;
  text-align: center;
}

.contact-us {
  margin-top: 20px;
  color: #fff;
  padding-top: 20px;
  text-align: center;
  padding-bottom: 10px;
  margin-bottom: 10px;
  background: #28d6ec;

  .contact-title {
    font-size: 26px;
    font-weight: 600;
    color: #fff;
    text-align: center;
  }

  .contact-con {
    width: auto;
    display: inline-block;
    margin: 0 auto;
    text-align: center;
  }

  .contact-text {
    text-align: center;
    margin: 10px auto;
  }

  .em-web {
    margin: 10px auto;
    justify-content: space-between;
    align-items: center;
    display: flex;
  }

  .em-web p {
    margin-bottom: 6px;
  }

  .em-web p:nth-of-type(1) {
    margin-right: 20px;
  }

  .mt-20 {
    margin-top: 50px;
  }
}

.people {
  margin-top: 15px;

  .btn {
    text-align: center;
    margin: 30px 0;

    span {
      cursor: pointer;
      background: #28d6ec;
      text-shadow: 0.2px 0.2px 1px rgba(0, 0, 0, 0.5);
      box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.15);
      padding: 10px 20px;
      border-radius: 50px;
      display: inline-block;
      color: white;
      margin-bottom: 16px;
    }
  }

  .people-title {
    background: #28d6ec;
    color: #fff;
    height: 40px;
    font-size: 16px;
    font-weight: 600;
    align-items: center;
    display: flex;
    padding-left: 15px;
  }

  .people-title i {
    margin-right: 8px;
    font-size: 18px;
  }

  .people-lists {
    display: flex;
    padding: 15px 10px 25px;
    box-sizing: border-box;
  }

  .h-350 {
    height: 350px;
  }

  .people-list {
    width: calc(20% - 10px);
    margin-right: 5px;
  }

  .people-pic {
    width: 110px;
    height: 150px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid #ccc;
    // background: #ddd;
    margin: 0 auto;
    border-radius: 4px;
  }

  .people-pic img {
    width: auto;
    height: 100%;
  }

  .people-title {
    font-weight: 600;
    text-align: center;
  }

  .peoples-title {
    text-align: center;
    padding-top: 6px;
    font-size: 12px;
  }

  .people-text {
    box-sizing: border-box;
    text-align: center;
    color: #666;
  }
}

.dates {
  background: #28d6ec;
  color: #fff;
  margin-top: 50px;
  padding-top: 50px;

  .title {
    font-size: 32px;
    text-align: center;
    font-weight: 600;
  }

  .lists {
    display: flex;
    align-items: center;
    margin-top: 30px;
    padding-bottom: 50px;
  }

  .list {
    border-right: 1px solid #fff;
    text-align: center;
    flex: 1;
    padding: 10px 0;
    font-size: 20px;
  }

  .list p {
    font-size: 20px;
  }

  .list:nth-last-of-type(1) {
    border-right: 0;
  }

  .list p:nth-of-type(1) {
    margin-bottom: 18px;
  }
}

.type-lists {
  display: flex;
  flex-wrap: wrap;
  color: #595959;
  padding-bottom: 50px;

  .pics {
    width: 100%;
    // display: flex;

    .pic {
      flex-shrink: 0;
      width: auto;
      height: 66px;
    }
  }

  .w-718 {
    width: 718px;
  }

  .type-list {
    width: calc(50% - 15px);
    margin-top: 30px;
  }

  .type-list:nth-of-type(2n) {
    margin-left: 30px;
  }

  .title {
    color: #28d6ec;
    font-size: 22px;
    font-weight: 600;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }

  .text {
    line-height: 24px;
    font-size: 16px;
    margin-bottom: 24px;
  }

  .btn span {
    cursor: pointer;
    background: #28d6ec;
    text-shadow: 0.2px 0.2px 1px rgba(0, 0, 0, 0.5);
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.15);
    padding: 10px 20px;
    border-radius: 50px;
    display: inline-block;
    color: white;
    margin-bottom: 16px;
  }

  .text-blue {
    color: #28d6ec;
    cursor: pointer;
    text-decoration: underline;
  }

  .pic {
    width: 60%;
    height: auto;
  }

  .gif {
    width: auto;
    height: 14px;
  }

  .square {
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-left: 15px solid #28d6ec;
  }

  .flex-1 {
    width: 100%;
  }
}

.message {
  .title {
    color: #28d6ec;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    margin-top: 60px;
    margin-bottom: 24px;
  }

  .small-title {
    font-size: 20px;
    color: #595959;
    text-align: center;
    margin-bottom: 26px;
    font-weight: 900;
  }

  .small-title2 {
    font-size: 20px;
    color: #595959;
    text-align: center;
    margin-bottom: 24px;
  }

  .small-title3 {
    font-size: 25px;
    color: #595959;
    text-align: center;
    font-weight: 900;
  }

  .line {
    width: 290px;
    margin: 10px auto 30px;
    height: 1px;
    margin-bottom: 24px;
    background: #7f7f7f;
  }

  .text {
    font-size: 16px;
    color: #7f7f7f;
    line-height: 24px;
    padding-bottom: 40px;

    p {
      margin-top: 10px;

      b {
        font-size: 17px;
        margin-bottom: 5px;
        display: inline-block;
      }
    }
  }
}

.index-con {
  max-width: 1200px;
  margin: 0 auto;
}

.swiper,
.el-carousel__container,
.swiper-item {
  height: 300px !important;
  width: 100%;

  .swiper-item {
    width: 100%;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to bottom, #8cd1f9, #248bbc);
  }

  .swiper-item-img {
    width: 100%;
    height: auto;
  }
}

.index {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .swiper,
  .el-carousel__container,
  .swiper-item {
    height: 150px !important;

    .swiper-item {
      align-items: start;
      height: 150px !important;
    }
  }

  .swiper .swiper-item-img,
  .el-carousel__container .swiper-item-img,
  .swiper-item .swiper-item-img {
    height: 100%;
    width: auto;
  }

  .message {
    zoom: 0.8;

    .text {
      padding: 0 14px;
      box-sizing: border-box;
    }
  }

  .type-lists {
    display: block;
    padding: 14px;
    box-sizing: border-box;
    zoom: 0.8;

    .type-list {
      width: 100%;
      margin-right: 0;
      margin-left: 0;
    }

    .type-list:nth-of-type(2n) {
      margin-left: 0;
    }
  }

  .dates {
    zoom: 0.8;
  }

  .people .people-list {
    width: calc(50% - 10px);
  }

  .contact-us {
    zoom: 0.8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue